import { styled } from '@mui/material/styles';
import { Box, Tooltip, Typography } from '@mui/material';
import { MouseEvent, useMemo } from 'react';
import { getAvatarBgColor } from 'utility/helpers';

export type StatusBarType = {
  id: string;
  displayName?: string;
  value: number;
  color?: string;
  backgroundColor?: string;
  tooltipMsg?: string;
};

type StatusBarProps = {
  data?: StatusBarType[];
  selectedValue?: StatusBarType;
  onSelect?: (event: MouseEvent, options: { item: StatusBarType }) => void;
};

function StatusBar({ data, selectedValue, onSelect }: StatusBarProps) {
  const { totalValue } = useMemo(() => {
    let totalValue = 0;
    data?.forEach((item) => {
      totalValue += item.value;
    });
    return { totalValue };
  }, [data]);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        display="flex"
        alignItems="center"
        minWidth={200}
        width="100%"
        sx={{ borderRadius: '2px', overflow: 'hidden' }}
      >
        {data?.map((item, index) => (
          <Tooltip
            placement="top"
            title={item.tooltipMsg && <TooltipMsg>{item.tooltipMsg}</TooltipMsg>}
          >
            <Box
              key={item.id}
              sx={(theme) => ({
                transition: 'height 0.1s',
                height: selectedValue?.id === item.id ? 30 : 25,
                minWidth: 20,
                pt: 0.25,
                pl: 0.25,
                cursor: 'pointer',
                width: `${(item.value / totalValue) * 100}%`,
                backgroundColor:
                  item.backgroundColor ||
                  getAvatarBgColor(String(index | item.value) || '', 30, 50),
              })}
              onClick={(event) => onSelect?.(event, { item })}
            >
              <Typography
                sx={(theme) => ({
                  color: item.color || theme.palette.custom.white,
                  fontWeight: 700,
                  fontSize: 14,
                })}
              >
                {item.displayName || item.value}
              </Typography>
            </Box>
          </Tooltip>
        ))}
      </Box>
      <Typography
        sx={(theme) => ({ color: theme.palette.custom.mistBlue, fontSize: 14, fontWeight: 700 })}
      >
        ({totalValue})
      </Typography>
    </Box>
  );
}

const TooltipMsg = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: 12,
  fontWeight: 600,
}));

export default StatusBar;
